<template>
    <MainContent title="Crear indumentaria">
        <template v-slot:header>
            <h3 class="card-title">Crear Indumentaria</h3>
        </template>
        <template v-slot:content>
            <div class="row" v-if="!loading">
                <div class="col-12">
                    <FormIndumentaria :indumentaria="indumentaria" @terminado="crearIndumentaria"/>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import FormIndumentaria from '@/components/backend/bases/indumentarias/FormIndumentaria';

    export default {    
        data() {
            return {
                indumentaria: {},
                loading: false,
                conf: {}
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            },
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crearIndumentaria();
                }
            },
            crearIndumentaria() {
                this.loading = true;

                this.indumentaria.filters = {};
                this.indumentaria.lista_id = this.lista_id;

                this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.crear'), this.indumentaria).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.bases.indumentarias.index', params: { lista_id: this.lista_id } });
                }).finally(() => this.loading = false);
            },
        },
        components: {
            MainContent, FormIndumentaria
        }
    }
</script>
